'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dDashboard$002dHost$002dStats from "./presto.types$-Dashboard-Host-Stats.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DashboardHostStats$() {
}
export { $c_Lpresto_types$DashboardHostStats$ as $c_Lpresto_types$DashboardHostStats$ };
$p = $c_Lpresto_types$DashboardHostStats$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DashboardHostStats$;
/** @constructor */
function $h_Lpresto_types$DashboardHostStats$() {
}
export { $h_Lpresto_types$DashboardHostStats$ as $h_Lpresto_types$DashboardHostStats$ };
$h_Lpresto_types$DashboardHostStats$.prototype = $p;
$p.l = (function() {
  return "DashboardHostStats";
});
$p.cGm = (function(x$0) {
  return new $j_presto$002etypes$0024$002dDashboard$002dHost$002dStats.$c_Lpresto_types$DashboardHostStats(x$0.j(0), (x$0.j(1) | 0), (x$0.j(2) | 0), (+x$0.j(3)), (+x$0.j(4)));
});
var $d_Lpresto_types$DashboardHostStats$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DashboardHostStats$, "presto.types$DashboardHostStats$", ({
  Zb: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$DashboardHostStats$ as $d_Lpresto_types$DashboardHostStats$ };
var $n_Lpresto_types$DashboardHostStats$;
function $m_Lpresto_types$DashboardHostStats$() {
  if ((!$n_Lpresto_types$DashboardHostStats$)) {
    $n_Lpresto_types$DashboardHostStats$ = new $c_Lpresto_types$DashboardHostStats$();
  }
  return $n_Lpresto_types$DashboardHostStats$;
}
export { $m_Lpresto_types$DashboardHostStats$ as $m_Lpresto_types$DashboardHostStats$ };
//# sourceMappingURL=presto.types$-Dashboard-Host-Stats$.js.map
